export default __webpack_public_path__ + "static/media/selective-redaction.1446c65b.svg";